export default {"src":"/_next/static/media/arrowLeft.246a2812.svg","height":15,"width":9,"blurWidth":0,"blurHeight":0};